export enum EPhaseNames {
  INITIAL = "Initiation Phase",
  SCOPING = "Scoping Phase",
  DESIGN = "Design Phase",
  PREREQUISITES = "Prerequisites Phase",
  SCHEDULING = "Scheduling Phase",
  CONSTRUCTION = "Construction Phase",
  POSTING = "Posting Phase",
  COMPLETED = "Completed",
  CANCELLED = "Cancelled",
}

export const EPhaseNamesValues = [
  EPhaseNames.INITIAL,
  EPhaseNames.SCOPING,
  EPhaseNames.DESIGN,
  EPhaseNames.PREREQUISITES,
  EPhaseNames.SCHEDULING,
  EPhaseNames.CONSTRUCTION,
  EPhaseNames.POSTING,
  EPhaseNames.COMPLETED,
  EPhaseNames.CANCELLED,
] as const;

export function parsePhaseName(
  input: string,
  ignoreCase = true
): EPhaseNames | null {
  if (ignoreCase) {
    input = input.toLowerCase();
  }

  const found = ignoreCase
    ? EPhaseNamesValues.find((x) => x.toLowerCase() === input)
    : EPhaseNamesValues.find((x) => x === input);
  if (found) {
    return found;
  } else {
    return null;
  }
}

export enum EPhaseStates {
  ACTIVE = "active",
  PENDING = "pending",
  COMPLETE = "complete",
}

export enum EBadgeStatuses {
  AT_RISK = "AT RISK",
  CRITICAL = "CRITICAL",
  ON_TIME = "ON TIME",
}
